import { render, staticRenderFns } from "./RoomDetailsDialog.vue?vue&type=template&id=47f2c558&scoped=true&"
import script from "./RoomDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./RoomDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoomDetailsDialog.vue?vue&type=style&index=0&id=47f2c558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2c558",
  null
  
)

export default component.exports